import type React from 'react';

import { getDocument } from '@atlaskit/browser-apis';

import type { LinkListClickOpts } from './types';

interface LinkClickHandlers {
	onAuxClick: ((e: React.MouseEvent) => void) | undefined;
	onClick: ((event: React.MouseEvent | React.KeyboardEvent) => void) | undefined;
	onContextMenu: ((e: React.MouseEvent) => void) | undefined;
}

export const createLinkClickHandlers = (
	onLinkClick: ((url: string, idx: number, opts?: LinkListClickOpts) => void) | undefined,
	url: string,
	idx: number,
	openLinksInNewTab = false,
): LinkClickHandlers => {
	if (!onLinkClick && !openLinksInNewTab) {
		return { onClick: undefined, onAuxClick: undefined, onContextMenu: undefined };
	}

	return {
		onClick: (event) => {
			if (openLinksInNewTab) {
				event.preventDefault();
				getDocument()?.defaultView?.open(url, '_blank', 'noopener,noreferrer');
			}
			onLinkClick?.(url, idx);
		},
		onAuxClick: (e: React.MouseEvent) => {
			if (e.button === 1) {
				onLinkClick?.(url, idx, { isAuxClick: true });
			}
		},
		onContextMenu: (_e: React.MouseEvent) => onLinkClick?.(url, idx, { isContextMenu: true }),
	};
};
